__turbopack_context__.v({
  "bar": "bracketScale-module-scss-module__jzAHiq__bar",
  "bars": "bracketScale-module-scss-module__jzAHiq__bars",
  "borderline": "bracketScale-module-scss-module__jzAHiq__borderline",
  "captions": "bracketScale-module-scss-module__jzAHiq__captions",
  "fill": "bracketScale-module-scss-module__jzAHiq__fill",
  "fits": "bracketScale-module-scss-module__jzAHiq__fits",
  "number": "bracketScale-module-scss-module__jzAHiq__number",
  "rise": "bracketScale-module-scss-module__jzAHiq__rise",
  "scale": "bracketScale-module-scss-module__jzAHiq__scale",
});
